<div class="c__search-input" [hidden]="!(hasFormToggle || (openedSearch && (isTablet$ || isMobile$)))">
  <sd-form-input
    #searchInput
    class="c__search-btn"
    (inputChanged)="openSearchResultBar($event)"
    (submitted)="onSubmit()"
    (clear)="onClear()"
    (blurEvent)="onBlur()"
    (keydown.enter)="onSubmit()"
    (inputActive)="inputIsActive()"
    [theme]="alpha ? themesEnum.light : ''"
    autocomplete="off"
    [labelTitle]="('navigation.search.placeholder' | translate)"
    [labelHidden]="true"
    type="search"
    [placeholder]="placeholder"
    nameField="search-field"
  />
  @if (openedSearch && (isTablet$ || isMobile$)) {
    <button sd-button-icon
      icon="icon-cross"
      [size]="iconSize.small"
      [buttonIconTitle]="(openedSearch ? 'navigation.search.closeSearch' : 'navigation.search.openSearch') | translate"
      (click)="toggleSearch()"
      [attr.aria-label]="(openedSearch ? 'navigation.search.closeSearch' : 'navigation.search.openSearch') | translate"
    ></button>
  }
</div>

<div
  class="c--search {{ openedSearch ? 'is-open' : '' }}"
  [attr.aria-expanded]="openedSearch"
  (keydown.escape)="toggleSearch()"
  [@expandCollapse]="openedSearch ? '1-auto' : '0'"
>
  @if ((isFilled && !hasSuggestion) || hasSuggestion) {
    <div class="c__search-bottom">
      <div class="container">
        <div class="row">
          @if (isFilled) {
            @if (results) {
              <ng-container>
                @if (searchData?.categories?.items?.length > 0) {
                  <div class="col-24 col-m-6 col-l-4 is-category">
                    <h4 class="{{isMobile$ ? 'is-caption' : 'is-body-s'}} is-bold">{{ 'navigation.search.categories' | translate }}</h4>
                    <ul sd-list-block>
                      @for (category of searchData?.categories?.items; track category.url) {
                        <li>
                          <sd-link [link]="{url: category.url}" (clicked)="toggleSearch()" customClass="is-reset">
                            <sd-html [html]="category.title" [bold]="searchTerms" tag="span" />
                          </sd-link>
                        </li>
                      }
                    </ul>
                  </div>
                }
                <div class="col-24 col-m-18 col-l-20">
                  <div class="row">
                    @if (searchData?.products?.items?.length > 0) {
                      <ng-container *ngTemplateOutlet="productTemplate; context: {
                        title:'navigation.search.products',
                        dataItems:searchData?.products?.items,
                        dataLink:searchData?.products?.seeAllLink,
                        seeAll:'navigation.search.seeAllProducts',
                        total:searchData?.products.total
                      }" />
                    }

                    @if (searchData?.sets?.items?.length > 0) {
                      <ng-container *ngTemplateOutlet="productTemplate; context: {
                        title:'navigation.search.sets',
                        dataItems:searchData?.sets?.items,
                        dataLink:searchData?.sets?.seeAllLink,
                        seeAll:'navigation.search.seeAllSets',
                        total:searchData?.sets.total
                      }" />
                    }

                    @if (searchData?.accessories?.items?.length > 0) {
                      <ng-container *ngTemplateOutlet="productTemplate; context:{
                        title:'navigation.search.accessories',
                        dataItems:searchData?.accessories?.items,
                        dataLink:searchData?.accessories?.seeAllLink,
                        seeAll:'navigation.search.seeAllAccessories',
                        total:searchData?.accessories.total
                      }" />
                    }

                    @if (searchData?.recipes?.items?.length > 0) {
                      <ng-container *ngTemplateOutlet="productTemplate; context: {
                        title:'navigation.search.recipes',
                        dataItems:searchData?.recipes?.items,
                        dataLink:searchData?.recipes?.seeAllLink,
                        seeAll:'navigation.search.seeAllRecipes',
                        total:searchData?.recipes.total
                      }" />
                    }

                    @if (searchData?.articles?.items?.length > 0) {
                      <div class="col-24 col-m-24 col-l-8 is-article">
                        <h4 class="{{isMobile$ ? 'is-caption' : 'is-body-s'}} is-bold">{{ 'navigation.search.articles' | translate }}</h4>
                        <ul sd-list-block>
                          @for (article of searchData?.articles?.items; track article) {
                            <li>
                              <sd-preview-article [data]="article" (clicked)="toggleSearch()" />
                            </li>
                          }
                        </ul>
                        @if (searchData?.articles?.seeAllLink && searchData?.articles?.total > 2) {
                          <sd-link
                            [link]="{url: searchData?.articles?.seeAllLink}"
                            (clicked)="toggleSearch()"
                            class="c__see-all-container"
                            customClass="c__link-see-all"
                          >
                            {{ 'navigation.menu.seeAllArticles' | translate }} ({{ searchData?.articles?.total }})
                          </sd-link>
                        }
                      </div>
                    }
                    @if (searchData?.others?.items?.length > 0) {
                      <ng-container *ngTemplateOutlet="productTemplate;context:{
                        title:'navigation.search.others',
                        dataItems:searchData?.others?.items,
                        dataLink:searchData?.others?.seeAllLink,
                        seeAll:'navigation.search.seeAllOthers',
                        total:searchData?.others.total
                      }" />
                    }
                  </div>
                </div>
              </ng-container>

              @if (isMobile$ || isTablet$) {
                <button sd-button
                  class="c__see-all-results"
                  (click)="onSubmit()"
                  [isSecondary]="true"
                >
                  {{'navigation.menu.seeAllResults' | translate}} ({{getTotalSearchResults()}})
                </button>
              }
            } @else {
              <div class="has-no-result">
                <p class="is-body-m">{{ 'navigation.search.noResult' | translate }}</p>
              </div>
            }
          } @else {
            <ng-container>
              @if (searchData?.mostSearched?.items?.length > 0) {
                <div class="col-24 col-m-6 col-l-4 is-category">
                  <h4 class="{{isMobile$ ? 'is-caption' : 'is-body-s'}} is-bold">{{ 'navigation.search.mostSearched' | translate }}</h4>
                  <ul sd-list-block>
                    @for (mostSearch of searchData?.mostSearched?.items; track mostSearch) {
                      <li>
                        <sd-link [link]="{url: mostSearch.url}" (clicked)="toggleSearch()" customClass="is-reset">
                          {{ mostSearch.title }}
                        </sd-link>
                      </li>
                    }
                  </ul>
                </div>
              }
              @if (pushTemplate) {
                <div class="col-16 col-m-18 col-l-6">
                  <h4 class="{{isMobile$ ? 'is-caption' : 'is-body-s'}} is-bold">{{ 'navigation.search.pushTitle' | translate }}</h4>
                  <ng-container *ngTemplateOutlet="pushTemplate" />
                </div>
              }
              @if (searchData?.starProducts?.items?.length > 0) {
                <div class="col-16 offset-m-6 col-m-18 offset-l-0 col-l-12 is-item is-star-product">
                  <h4 class="{{isMobile$ ? 'is-caption' : 'is-body-s'}} is-bold">{{ 'navigation.search.starProducts' | translate }}</h4>
                  <ul sd-list-inline>
                    @for (product of searchData?.starProducts?.items; track product) {
                      <li>
                        <sd-navigation-product-card
                          [indexFollow]="product?.indexFollow !== undefined ? product?.indexFollow : true"
                          [productInfo]="product"
                          [isReadOnly]="true"
                          (clicked)="toggleSearch($event)"
                          (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
                        />
                      </li>
                    }
                  </ul>
                </div>
              }
            </ng-container>
          }
        </div>
      </div>
    </div>
  }
</div>

<ng-template #productTemplate
  let-title="title"
  let-dataItems="dataItems"
  let-dataLink="dataLink"
  let-seeAll="seeAll"
  let-total="total"
>
  <div class="col-24 col-m-24 col-l-8 is-item">
    <h4 class="{{isMobile$ ? 'is-caption' : 'is-body-s'}} is-bold">{{ title | translate }}</h4>
    <ng-container *ngTemplateOutlet="productItemsTemplate; context: {
      dataItems: dataItems,
      dataLink: dataLink,
      seeAll: seeAll,
      total: total
    }" />
  </div>
</ng-template>

<ng-template #productItemsTemplate
  let-dataItems="dataItems"
  let-dataLink="dataLink"
  let-seeAll="seeAll"
  let-total="total"
>
  <ul sd-list-block>
    @for (item of dataItems; track item) {
      <li>
        <sd-navigation-product-card
          [indexFollow]="item?.indexFollow !== undefined ? item?.indexFollow : true"
          [productInfo]="item"
          [isReadOnly]="true"
          (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
          (clicked)="toggleSearch($event)"
        />
      </li>
    }
  </ul>
  @if (dataLink && total > 2) {
    <sd-link
      [link]="{url: dataLink}"
      class="c__see-all-container"
      (clicked)="toggleSearch($event)"
      customClass="c__link-see-all"
    >
      {{ seeAll | translate }} ({{ total }})
    </sd-link>
  }
</ng-template>
